import { WebsocketsService } from 'app/API';
import { useEffect } from 'react';

const RETRY_DELAY_MS = 3000;

export const useAdminJobDetailsSubscription = (websocketSessionId: string | null, jobId: string) => {
  useEffect(() => {
    if (!websocketSessionId || !jobId) {
      return;
    }

    let subscribed = false;
    let cancelled = false;
    let retryTimeout: ReturnType<typeof setTimeout> | null = null;

    const unsubscribe = () => {
      WebsocketsService.unsubscribeAdminJobDetails({
        requestBody: {
          sessionId: websocketSessionId,
          jobId,
        },
      }).catch((error) => {
        console.error('Failed to unsubscribe admin job details websocket:', error);
      });
    };

    const subscribe = () => {
      WebsocketsService.subscribeAdminJobDetails({
        requestBody: {
          sessionId: websocketSessionId,
          jobId,
        },
      })
        .then(() => {
          subscribed = true;
          if (cancelled) {
            unsubscribe();
          }
        })
        .catch((error) => {
          console.error('Failed to subscribe admin job details websocket:', error);
          if (!cancelled) {
            retryTimeout = setTimeout(subscribe, RETRY_DELAY_MS);
          }
        });
    };

    subscribe();

    return () => {
      cancelled = true;
      if (retryTimeout) {
        clearTimeout(retryTimeout);
      }
      if (subscribed) {
        unsubscribe();
      }
    };
  }, [jobId, websocketSessionId]);
};
